/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Boost 213192 */
const customize = {
  moveCollectionDescription: (componentRegistry) => {
    componentRegistry.useComponentPlugin("HeaderDescription", {
      name: "Move Collection Description",
      enabled: true,
      apply: () => ({
        props: (props) => {
          return props;
        },
        afterRender(element) {
                try{
                  let hasUpdated; // Prevent rendering twice
                  if (hasUpdated == null) {
                      hasUpdated = false;
                  }
                  if (boostSDAppConfig.generalSettings.collection_handle == 'marriage-ring' || 
                     boostSDAppConfig.generalSettings.collection_handle == 'wedding-jewelry' ||
                     boostSDAppConfig.generalSettings.collection_handle == 'bridal-all') {
                        const descriptionElement = element.getRootElm();
                        if (document.querySelector('.boost-sd__header-main-4-content')) {
                          const productListContainerElement = document.querySelector(
                            '.boost-sd__header-main-4-content'
                          ); // Select product list
                          if (productListContainerElement && hasUpdated == false) {
                            productListContainerElement.appendChild(descriptionElement); // Move to below product list
                            hasUpdated = true;
                          }
                        }
                  }
                } catch (e) {
                  console.log(e);
                }
        },
      }),
    });
  },
};
/* Boost 213192 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterOptionRangeSlider', {
            name: 'FilterOption - Customize filter range slider #211361',
            apply: () => ({
                props: (props, element) => {
                    try {
                        if (props?.option?.displayType == 'range' && props?.option?.filterType == 'price') {
                            props.sliderRange = '4';
                            props.option.hideTextBoxes = false;
                        }
                        return props;
                    } catch(error) {
                        console.log(error);
                        return props;
                    }
                },
            }),
        });
    }, 
  customize.moveCollectionDescription,
]);

// Start Boost 215685
const customHeader = {
    changeColorTitle: (componentRegistry) => {
      componentRegistry.useComponentPlugin("HeaderTitle", {
          name: "Change Color Collection title #215685",
          apply: () => {
              let hasUpdated = false; // Prevent rendering twice
              return {
                  afterInit(element) {
                      const titleElement = element.getRootElm();
                      if (titleElement && !hasUpdated) {
                          hasUpdated = true;
                          const collectionHandles = ['marriage-ring', 'bridal-all', 'engage-ring'];
                          const collectionHandle = boostSDAppConfig.generalSettings.collection_handle;
                      
                          if (collectionHandles.includes(collectionHandle)) {
                              titleElement.classList.add("boost-sd__header-custom-title");
                          }
                        
                      }
                  },
              };
          },
      });
    }
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customHeader.changeColorTitle,
]);

// End boost 215685

const updateProductItem3 = (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Add SKU and specsheet to product card',
        enabled: true,
        apply: () => ({
            afterRender(element){
                try{
                    let productData = element.getParams()?.props?.product || element.getParams()?.props?.productData || element.getParams()?.props?.data;
                    let productItem = document.querySelector('[data-product-id="'+ productData.id +'"]');
                    if(!productItem) return;

                    /* Boost 216669*/
                    if (productItem.querySelector('.boost-sd__product-image-column.boost-sd__product-image-column--in-bottom.boost-sd__product-image-column--right button')) {
                      productItem.querySelector('.boost-sd__product-image-column.boost-sd__product-image-column--in-bottom.boost-sd__product-image-column--right button').removeAttribute("disabled");
                    }
                    /* END Boost 216669*/
                } catch (e) {
                }
            }
        }),

    });
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem3]);